import { createFileRoute } from "@tanstack/react-router";

import ConsentPage from "./-components/ConsentPage";

export const Route = createFileRoute("/_app/oauth/consent")({
  component: ConsentPage,
});
